import { ContentTypeCodenames } from "services/cms/models/contentTypeCodenames";
import type { Testimonials } from "services/cms/models/testimonials";

import type { ResolvedImage } from "./imageResolver";
import imageResolver from "./imageResolver";

export interface ResolvedTestimonials {
    heading: string;
    sectionName: string;
    logo: ResolvedImage;
    codename: string;
    type: ContentTypeCodenames.Testimonials;
}

const testimonialsResolver = (data: Testimonials): ResolvedTestimonials => {
    return {
        codename: data.system.codename,
        sectionName: data.elements.sectionName.value,
        heading: data.elements.heading.value,
        logo: imageResolver(data.elements.logo.linkedItems[0]),
        type: ContentTypeCodenames.Testimonials,
    };
};

export default testimonialsResolver;
